import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import FullScreenLoader from "./ui/FullScreenLoader";

export default function ProtectedRoute({ children, roles }) {
  const { user, loading } = useAuth();

  if (loading) return <FullScreenLoader text="Authentifiziere Benutzer..." />;
  if (!user) return <Navigate to="/login" />;

  // Rollen-Check
  if (roles && !roles.includes(user.role)) {
    return <Navigate to="/unauthorized" />;
  }

  return children;
}
